/* 🤖 this file was generated by svg-to-ts */
export const iconCoinbasewallet: {
  name: 'coinbasewallet';
  data: string;
} = {
  name: 'coinbasewallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m.01 21.63c2.78 0 5.09-2.03 5.54-4.69h5.67c-.48 5.78-5.31 10.31-11.21 10.31C9.8 27.25 4.76 22.21 4.76 16S9.8 4.75 16.01 4.75s10.73 4.54 11.21 10.31h-5.67a5.619 5.619 0 0 0-11.16.93c0 3.1 2.52 5.62 5.62 5.62z"/></svg>`,
};
